import { createFileRoute, redirect } from '@tanstack/react-router'

// /account → redirige a /account/profile (primer tab del hub)
export const Route = createFileRoute('/_app/account/')({
  beforeLoad: () => {
    throw redirect({ to: '/account/profile', replace: true })
  },
})
